/**
 * Created by mac on 3/4/21
 */

cc.PlaySound = function (sound, options) {
    cc.ActionInstant.prototype.constructor.call(this);

    this.sound = sound;
    this.options = options;
};

cc.PlaySound.prototype = Object.assign(Object.create(cc.ActionInstant.prototype), {
    constructor: cc.PlaySound,

    update: function () {
        cleverapps.audio.playSound(this.sound, this.options);
    },

    _autoFinalize: function () {}
});